<a [routerLink]="['/post']"
   [queryParams]="{activeAccount: activeAccount, influencerId: interactionPost.influencerId, fullUrl: interactionPost.url, relativePath: interactionPost.relativepath, urlHash: interactionPost.urlHash}"
   target="_blank" class="d-flex flex-auto interaction-item-container full-width">
  <div class="d-flex flex-row flex-auto full-width">
    <div class="post-details-col">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="d-flex flex-nowrap flex-row">
            <div class="d-flex counter-number">
              {{index}}
            </div>
            <div class="d-flex interaction-text-wrapper mr-2">
              <blurry-backdrop-image [image]="interactionPost.imageUrl" (afterLoaded)="onLoadedImage()" (error)="onLoadedImage()" class="post-img"></blurry-backdrop-image>
            </div>
            <div class="d-flex flex-column post-title">
              <a class="interaction-text-wrapper">{{interactionPost.title}}</a>
              <span class="influencer-name">{{interactionPost.influencerName}}</span>
            </div>
            <div class="d-flex justify-content-end platform-icon-container">
              <img src="{{getPlatformIcon(interactionPost.platform)}}"
                   onerror="this.onerror=null;this.src='assets/images/No_Image.png'"
                   width="20" height="20">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="audience-col">
      <div class="interaction-statictis d-flex justify-content-start align-items-center">
        <span placement="bottom"
              ngbTooltip="{{'info_box.measure.audience_col' | translate}}">
          {{interactionPost.audience | thousandNumberSuffix:1}}
        </span>
      </div>
    </div>
    <div class="interaction-col">
      <div class="interaction-statictis d-flex justify-content-start align-items-center">
        <span placement="bottom"
              ngbTooltip="{{'info_box.measure.interaction_col' | translate}}">
          {{interactionPost.interaction | formatInteractionNumber:interactionPost.authorized:interactionPost.story}}
        </span>
      </div>
    </div>
    <div class="percentage-col">
      <div class="interaction-statictis d-flex justify-content-start align-items-center">
        <span placement="bottom"
              ngbTooltip="{{'info_box.measure.percentage_col' | translate}}">
          {{interactionPost.percentage | formatInteractionPercentage:interactionPost.authorized:interactionPost.story}}
        </span>
      </div>
    </div>
  </div>
</a>



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/interaction-report/interaction-report-item/interaction-report-item.component.html